export function dateFormat (time, connect = '') {
    time = new Date(time);
    let year = time.getFullYear().toString();
    let month = (time.getMonth()+1).toString();
    let day = time.getDate().toString();
    return `${year}${connect}${month < 10 ? `0${ month}` : month}${connect}${day < 10 ? `0${ day}` : day}`
}